import { WabunkaExperienceListResponse } from '@japan-culture-and-technology/wabunka-protos/ts_proto/wabunka_experience';
import { useLocalStorage } from '@vueuse/core';

import { useAsyncFetchFromPublicWabunkaApi } from '@/composables/models/wabunka/useAsyncFetchFromPublicWabunkaApi';
import { buildWabunkaExperienceBrowsingHistoryListViewModel, type WabunkaExperienceListViewModel } from '@/models/wabunka/wabunkaExperience';
import { useCurrency } from '@/wabunka-src/common/composables/general/useCurrency/useCurrency';
import { WABUNKA_EXPERIENCE_BROWSING_HISTORY } from '@/wabunka-src/constants/wabunkaLocalStorageKeys';

const fetchExperienceBrowsingHistorySlugs = (): string[] => {
  if (process.server) {
    return [];
  }

  const historyStr = useLocalStorage(WABUNKA_EXPERIENCE_BROWSING_HISTORY, '');
  if (historyStr.value) {
    return historyStr.value.split(',');
  }

  return [];
};

export const useWabunkaExperienceBrowsingHistory = async () => {
  const historySlugs = fetchExperienceBrowsingHistorySlugs();
  const { selectedCurrency } = useCurrency();

  const query = computed(() => ({
    slugs: historySlugs.toString(),
    includes: 'experienceImages',
    currency: selectedCurrency.value !== 'JPY' ? selectedCurrency.value : undefined,
  }));

  const { data, refresh } = await useAsyncFetchFromPublicWabunkaApi({
    path: ref('/experiences/search'),
    query,
    options: {
      server: false,
      immediate: historySlugs.length > 0,
      watch: historySlugs.length > 0 ? [query] : [],
    },
    converter: WabunkaExperienceListResponse.fromJSON,
  });

  const experienceBrowsingHistory: Ref<WabunkaExperienceListViewModel> = computed(() => (data.value ? buildWabunkaExperienceBrowsingHistoryListViewModel(data.value, historySlugs) : []));

  return { experienceBrowsingHistory, refresh };
};
